export const config = {
  url: "https://blackbox.botza.net/v1",
};
